export default {
    url: state => state.url,
    apiToken: state => state.apiToken,
    details: state => state.details
}
